// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__39mR6","title":"styles_title__38ZOm"};